// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model, Q } from '@nozbe/watermelondb';
import { field, date, readonly, lazy } from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';
import { ProductModel } from '../../types/Products';

setGenerator(uuidv4);

export default class Product extends Model {
    static table = 'products';

    static associations = {
        entry_products: { type: 'has_many', foreignKey: 'product_id' },
        inventory_products: { type: 'has_many', foreignKey: 'product_id' },
        product_sales_units: { type: 'has_many', foreignKey: 'product_id' },
    };

    @lazy
    productSalesUnits = this.collections
        .get('product_sales_units')
        .query(Q.where('product_id', this.id));

    @field('name') name;
    @field('product_type') productType;
    @field('brand') brand;
    @field('family') family;
    @field('shape') shape;
    @field('dimensions') dimensions;
    @field('clips') clips;
    @field('shoe_size') shoeSize;
    @field('nail_size') nailSize;
    @field('product_size') productSize;
    @field('sku_apac') skuApac;
    @field('sku_emea') skuEmea;
    @field('uom_dealers') uomDealers;
    @field('user_id') userId;
    @field('organisation_id') organisationId;
    @date('created_at') createdAt;
    @date('updated_at') updatedAt;
    @field('material') material;
    @field('box_unit_size') boxUnitSize;
    @field('shoe_size_sort_num') shoeSizeSortNum;
    @field('not_available') notAvailable;
}

export type ProductSimple = {
    id: string;
    name: string;
    productType: ProductType;
    brand: string;
    family: string;
    shape: string;
    dimensions: string;
    clips: string;
    shoeSize: string;
    nailSize: string;
    productSize: string;
    skuApac: string;
    skuEmea: string;
    uomDealers: string;
    userId: string;
    organisationId: string;
    createdAt: string;
    updatedAt: string;
    material: string;
    boxUnitSize: string;
    shoeSizeSortNum: string;
    notAvailable: bool;
};

export type ProductPreview = Pick<ProductSimple, 'id' | 'name' | 'productType'>;

// Strip down the Product model to a simplified version, avoiding
// Watermelon's internal types and methods leaking to the app's state.
export function simplifyProduct(product: ProductModel): ProductSimple {
    return {
        id: product.id,
        name: product.name,
        productType: product.productType,
        brand: product.brand,
        family: product.family,
        shape: product.shape,
        dimensions: product.dimensions,
        clips: product.clips,
        shoeSize: product.shoeSize,
        nailSize: product.nailSize,
        productSize: product.productSize,
        skuApac: product.skuApac,
        skuEmea: product.skuEmea,
        uomDealers: product.uomDealers,
        userId: product.userId,
        organisationId: product.organisationId,
        createdAt: product.createdAt.toISOString(),
        updatedAt: product.updatedAt.toISOString(),
        material: product.material,
        boxUnitSize: product.boxUnitSize,
        shoeSizeSortNum: product.shoeSizeSortNum,
        notAvailable: product.notAvailable,
    };
}

export function simplifyProductPreview(product: ProductModel): ProductPreview {
    return {
        id: product.id,
        name: product.name,
        productType: product.productType,
    };
}

export const referenceProduct: Reference<ProductSimple> = {
    id: undefined,
    name: undefined,
    productType: undefined,
    brand: undefined,
    family: undefined,
    shape: undefined,
    dimensions: undefined,
    clips: undefined,
    shoeSize: undefined,
    nailSize: undefined,
    productSize: undefined,
    skuApac: undefined,
    skuEmea: undefined,
    uomDealers: undefined,
    userId: undefined,
    organisationId: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    material: undefined,
    boxUnitSize: undefined,
    shoeSizeSortNum: undefined,
    notAvailable: undefined,
};
